import { render, staticRenderFns } from "./teamList.vue?vue&type=template&id=228fed38&scoped=true"
import script from "./teamList.vue?vue&type=script&lang=js"
export * from "./teamList.vue?vue&type=script&lang=js"
import style0 from "./teamList.vue?vue&type=style&index=0&id=228fed38&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228fed38",
  null
  
)

export default component.exports